import UIManager from './UIManager';
const UI: UIManager = new UIManager();
export default UI;

export { default as UIManager } from './UIManager';
export * from './UIManager';

export { default as UIWrapper } from './UIWrapper';
export * from './UIWrapper';
